import classnames from 'classnames';

import { snakeCase } from 'lodash';
import { useContext } from 'react';

import InputGroupContext from '../../../scenes/InputGroupContext';

import { BadgeValues } from '.';
import { CheckMark } from '../../CheckMark';
import { Option } from '../../utils';
import { OptionBadges } from './OptionBadges';

import styles from '../index.module.css';

interface OptionEntryProps<T> {
  option: Option<T>;
  checked?: boolean;
  /** The action to take on badge click when applicable */
  onBadgeClick?: (option: string) => void;
  /** The action to take on check mark clicked */
  onItemClick?: (option: Option<T>) => void;
  /** The associated badge data for given option */
  optionBadgeValues?: BadgeValues;
  /** Whether to use small margin for row */
  smallRowMargin?: boolean;
  /** The translated text to display, if not given, label will default to option's display value */
  translation?: string;
}

/**
 * Render a single entry of enum option, display badgers
 * if the option have associated badge values
 */
export function OptionEntry<T>({
  option,
  onBadgeClick,
  checked,
  onItemClick,
  smallRowMargin,
  translation,
  optionBadgeValues,
}: OptionEntryProps<T>) {
  const inputGroup = useContext(InputGroupContext);
  return (
    <span key={option.key}>
      <CheckMark
        id={`${inputGroup ? `${inputGroup}-` : ''}${snakeCase(option.key)}`}
        label={translation || option.display}
        value={JSON.stringify(option.value)}
        checked={checked}
        onClick={() => onItemClick && onItemClick(option)}
        className={classnames({
          [styles.SmallCheckMarkRowMargin]: smallRowMargin,
        })}
      />
      {!!optionBadgeValues && (
        <OptionBadges
          onBadgeClick={() => onBadgeClick && onBadgeClick(option.display)}
          optionBadge={optionBadgeValues}
        />
      )}
    </span>
  );
}
